export default __webpack_public_path__ + "static/about-head-412a19a6450c3b7a64a7aa03f607cdf5.jpg";